export { default } from './es/icons/CloseFilled';